import { IApiError } from '@/models/apiError.model';
import { IAdminProfileResponse } from '@/models/admins.model';
import { IPagination } from '@/models/pagination.model';
import { TGetAdminsQuery, TGetUsersQuery } from '../helpers/types';
import { IUserProfile } from '@/models/users.model';

export const USERS_LIST_SLICE_NAME = 'usersList';

export interface UsersListState {
  admins: {
    data: IAdminProfileResponse[];
    meta: IPagination;
  } | null;
  users: {
    data: IUserProfile[];
    meta: IPagination;
  } | null;
  partners: {
    data: IAdminProfileResponse[];
    meta: IPagination;
  } | null;
  adminDetails: IAdminProfileResponse | null;
  isLoading: boolean;
  query: TGetAdminsQuery | null;
  userQuery: TGetUsersQuery | null;
  error: IApiError | null;
}

export const initialState: UsersListState = {
  admins: null,
  adminDetails: null,
  partners: null,
  users: null,
  query: null,
  userQuery: null,
  isLoading: false,
  error: null,
};
